// extracted by mini-css-extract-plugin
export default {"tabsContainer":"GridTab_tabsContainer__84p0g"};